import {ACTION_TYPE} from "utils/constants";

const initialState = {
  command: "",
  timestamp: "",
  isUndoAble: false,
  isRedoAble: false,
};

const undoredo = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.UNDO:
    case ACTION_TYPE.REDO:
      const {command, timestamp} = action.payload;
      return {...state, command, timestamp};
    case ACTION_TYPE.TOGGLE_UNDO_ABLE:
      return {...state, isUndoAble: action.payload};
    case ACTION_TYPE.TOGGLE_REDO_ABLE:
      return {...state, isRedoAble: action.payload};
    default:
      return state;
  }
};

export default undoredo;
